module.exports = __webpack_public_path__ + "media/images/pc/stores/asakusa/asakusa_concept_01-0ca0b40dcdb2f7ce8e358badd9b62cbb.jpg";